import bankDetailsDictionary from '@widgets/bank-details/i18n/ru/bank-details.dic.json';

export const bankDetails = {
  BANK_DETAILS2: bankDetailsDictionary,
};

export const bankDetailsNamespaces = Object.keys(bankDetails);
